const publicBase = typeof process.env.PUBLIC_URL === "string" ? process.env.PUBLIC_URL.replace(/\/$/, "") : "";

/** Navbar mark (44×44) — `public/radar-square.png` */
export const radarLogoSquare = `${publicBase}/radar-square.png`;

/** Footer mark — `public/radar-circle.png` */
export const radarLogoCircle = `${publicBase}/radar-circle.png`;

/** Wordmark — `public/text-logo.svg` */
export const radarTextLogo = `${publicBase}/text-logo.svg`;
